<template>
  <div id="bdm_distribute_reward" :class="isFull === 1 ? 'bdm_distribute_reward top_information1' : ' bdm_distribute_reward'">
    <van-nav-bar :title="$t('title.bdm_distribute_reward')" placeholder fixed left-arrow >
        <template #left>
            <img src="../assets/img/bdm/bdm_left.png" alt="" height="20vw" @click="onClickLeft">
        </template>
        <template #right>
            <img src="../assets/img/bdm/bdm_center_log.png" alt="" height="20vw" @click="onClickLog">
        </template>
    </van-nav-bar>
    <van-row>
      <!--  列表    -->
      <div class="reward-list">
        <div class="reward-item" v-for="(item, index) in list" :key="index">
          <div class="reward-img-wrapper">
            <div :id='"popular_svga" + index' class="reward-img" v-if="isSvga(item.img)"></div>
            <img :src="item.img" alt="" class="reward-img" v-else>
            <div class="play-icon" v-if="item.type== 2" @click.stop="playSvga(item.animation)"></div>
          </div>
          <div class="reward-name">{{item.title}}</div>
          <div class="reward-btn" @click="handleDistribute(item)">{{ $t('column.disdtribute') }}</div>
        </div>
      </div>

      <!-- Popup Dialog -->
      <van-popup v-model="showPopup" class="distribute-popup">
        <div class="popup-close" @click="showPopup = false">
          <van-icon name="cross" />
        </div>
        <div class="popup-content" v-if="currentItem">
          <div class="popup-img-wrapper">
            <div id="popup_popular_svga" class="popup-img" v-if="isSvga(currentItem.img)"></div>
            <img :src="currentItem.img" alt="" class="popup-img" v-else>
          </div>
          <div class="popup-title">{{currentItem.title}}</div>
          <div class="popup-validity">{{ $t('column.validity_period_days',{number: currentItem.days}) }}</div>
          
          <div class="popup-input-wrapper">
            <input type="text" v-model="userId" :placeholder="$t('column.enter_id')" class="popup-input">
          </div>
          <div class="popup-confirm-btn" @click="handleConfirm">{{ $t('btn.confirm') }}</div>
        </div>
      </van-popup>
      <van-overlay :show="loading" z-index="2003">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
      <van-overlay :show="svgaShow" @click="svgaHide" style="z-index: 3000;">
        <div id="svgaBox" @click.stop="svgaHide" style="height: 100vh;"></div>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'
import SVGA from "svgaplayerweb"

export default {
  data:function() {
    return {
      svgaShow: false,
      loading: false,
      finished: false,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      showPopup: false,
      currentItem: null,
      userId: '',
      list: []
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
    svgaHide() {
      this.svgaShow = false;
    },
    playSvga(url) {
      if (!url) return;
      this.svgaShow = true;
      this.$nextTick(() => {
        try {
          const player = new SVGA.Player('#svgaBox');
          const parser = new SVGA.Parser('#svgaBox');
          parser.load(url, (videoItem) => {
            player.loops = 1;
            player.setVideoItem(videoItem);
            player.startAnimation();
            player.onFinished(() => {
              this.svgaShow = false;
            });
          });
        } catch (error) {
          console.error(error);
        }
      });
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1)
    },
    onClickLog() {
        this.$router.push({
          path: '/bdm_distribute_reward_log',
          query: {
            token: this.$route.query.token,
            is_full: this.isFull,
          }
        })
    },
    handleDistribute(item) {
      this.currentItem = item
      this.userId = ''
      this.showPopup = true
      if (this.isSvga(item.img)) {
        this.$nextTick(() => {
          const player = new SVGA.Player('#popup_popular_svga');
          const parser = new SVGA.Parser('#popup_popular_svga');
          parser.load(item.img, function(videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          });
        });
      }
    },
    handleConfirm() {
      if (!this.userId) {
        Toast(this.$t('column.enter_id'))
        return
      }
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=send_dress_up",{ 
        params:{
          token: token,
          to_user_id: this.userId,
          id: this.currentItem.id
        }
      }).then(res =>{
        this.loading = false
        console.log(res)
        Toast(res.data.error);
        if(res.data.status===1){
          this.get_list()
          this.showPopup = false
        }
      })
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=dress_up_list",{ params:{token: token }}).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          this.list = res.data.data.list
          this.renderSVGA()
          this.finished = true
          this.loading = false
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    },
    isSvga(url) {
      if (!url) return false
      const cleanUrl = url.split('?')[0].split('#')[0]
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'svga'
    },
    renderSVGA() {
      this.$nextTick(() => {
        this.list.forEach((item, index) => {
          if (this.isSvga(item.img)) {
            const player = new SVGA.Player('#popular_svga' + index);
            const parser = new SVGA.Parser('#popular_svga' + index);
            parser.load(item.img, function(videoItem) {
              player.setVideoItem(videoItem);
              player.startAnimation();
            });
          }
        });
      });
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bdm_distribute_reward.vue